import { render, staticRenderFns } from "./campaignTargetAudiance.vue?vue&type=template&id=ec9d7d58&"
import script from "./campaignTargetAudiance.vue?vue&type=script&lang=js&"
export * from "./campaignTargetAudiance.vue?vue&type=script&lang=js&"
import style0 from "./campaignTargetAudiance.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports